import { z } from 'zod';

// Manta _publish after Meta confirms media delete.
export const schemaChatMediaDeletionCompletedPayload = z.object({
    mediaKey: z.string().min(1),
});

export type Schema_ChatMediaDeletionCompletedPayload = z.infer<typeof schemaChatMediaDeletionCompletedPayload>;
